




import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IWebhook } from "@/models/webhooks";

@Component({
  components: {
    "webhook-events-listing": () =>
      import(
        "@/components/app/admin/settings/webhooks/webhookEventsListing.vue"
      )
  }
})
export default class WebhookEventsView extends Vue {
  // Props

  @Prop({ required: true })
  public webhookId!: IWebhook["id"];
}
